export const navLinks = [
  {
    title: "Home",
    to: "/",
  },
  {
    title: "About Us",
    to: "/about",
  },
  {
    title: "Contact Us",
    to: "/contact",
  },
];
